import { z } from "zod";

const optional = () => z.string().optional().or(z.literal(""));
const optionalNum = () =>
  z
    .union([z.coerce.number(), z.nan(), z.literal("")])
    .optional()
    .transform((v) => (v === "" || v === undefined || Number.isNaN(v as number) ? undefined : Number(v)));

export const transporterFormSchema = z.object({
  code: z
    .string()
    .trim()
    .min(1, "Code required")
    .max(20)
    .regex(/^[A-Za-z0-9_-]+$/, "Use letters, numbers, - or _"),
  name: z.string().trim().min(1, "Name required").max(120),
  gstin: optional(),
  contact_person: optional(),
  phone: optional(),
  email: optional(),
  address: optional(),
  payment_terms: optional(),
  notes: optional(),
  is_active: z.boolean(),
});

export type TransporterFormValues = z.infer<typeof transporterFormSchema>;

export const emptyTransporterForm: TransporterFormValues = {
  code: "",
  name: "",
  gstin: "",
  contact_person: "",
  phone: "",
  email: "",
  address: "",
  payment_terms: "",
  notes: "",
  is_active: true,
};

export const driverFormSchema = z.object({
  name: z.string().trim().min(1, "Name required").max(100),
  phone: optional(),
  license_number: optional(),
  transporter_id: optional(),
  status: z.enum(["active", "inactive", "on_leave"]),
  notes: optional(),
  is_active: z.boolean(),
});

export type DriverFormValues = z.infer<typeof driverFormSchema>;

export const emptyDriverForm: DriverFormValues = {
  name: "",
  phone: "",
  license_number: "",
  transporter_id: "",
  status: "active",
  notes: "",
  is_active: true,
};

export const vehicleFormSchema = z.object({
  vehicle_number: z.string().trim().min(1, "Number required").max(30),
  vehicle_type: z.enum(["truck", "trailer", "tempo", "container", "other"]),
  capacity_tons: optionalNum(),
  transporter_id: optional(),
  driver_id: optional(),
  status: z.enum(["available", "on_trip", "inactive"]),
  rate_per_km: optionalNum(),
  notes: optional(),
  is_active: z.boolean(),
});

export type VehicleFormValues = z.infer<typeof vehicleFormSchema>;

export const emptyVehicleForm: VehicleFormValues = {
  vehicle_number: "",
  vehicle_type: "truck",
  capacity_tons: undefined,
  transporter_id: "",
  driver_id: "",
  status: "available",
  rate_per_km: undefined,
  notes: "",
  is_active: true,
};
